/**
 * Single-vehicle collision text for Entsia POST fields (incident vs damage are separate).
 * @module claims/singleVehicleSubmissionNarrative
 */

import { getSingleVehicleDescribeParts, type ClaimFlowDraft } from './claimDraftStorage'

/** “Tell us what happened” → `lossDetails.lossDescription`. */
export function singleVehicleIncidentForEntsia(draft: ClaimFlowDraft | null): string {
  return getSingleVehicleDescribeParts(draft).incident
}

/** Vehicle damage narrative → `fnolGeneral.damageDescription`. */
export function singleVehicleDamageForEntsia(draft: ClaimFlowDraft | null): string {
  return getSingleVehicleDescribeParts(draft).damage
}
